import React, { Component } from 'react';
import { Col, Container, Image, Row, Table } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import i18n from 'utils/I18n';

import CustomButton from 'component/base/CustomButton';
import CustomModal from 'component/base/CustomModal';
import LoadMoreSpinner from 'component/common/LoadMoreSpinner';
import ActivityLogFilterDropdown from 'component/profile/ActivityLogFilter';
import ActivityLogTransactionCard from 'component/profile/ActivityLogTransactionCard';
import ActivityLoginReachLimitContent from 'component/records/ActivityLoginReachLimitContent';
import TransactionDetailContent from 'component/records/TransactionDetailContent';

import { createAction, enLocaleNumberFormatter } from 'utils';
import { NO_TRANSACTION_HISTORY } from 'utils/Config';
import { detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';
import { strToBool } from 'utils/UrlUtils';

import './ActivityLogSection.scss';

import LeftArrow from 'assets/back-btn.svg';
import { getLogRewardItem } from 'models/ActivityLogs';

@connect(({ users, activityLogs, pullrefreshandloadmore }) => ({
  availablePoints: users.availablePoints,
  showNonReward: activityLogs.showNonReward,
  activityLogOriginList: activityLogs.activityLogOriginList,
  activityLogPageLink: activityLogs.activityLogPageLink,
  isLoadingLogs: activityLogs.isLoading,
  ...pullrefreshandloadmore,
  language: users.language,
}))
class ActivityLogSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      transactionID: null,
      reachLimitActivityID: null,
    };
    this.isMobile = detectIsPadOrMobileByScreenWidth();
  }

  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    this.props.dispatch(createAction('activityLogs/fetchUserActivityLogs')({
      showNonReward: strToBool(params.get("is_empty_reward"))
    }));
  }

  componentWillUnmount() {
    this.props.dispatch(createAction('activityLogs/clearLogs')());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.props.dispatch(createAction('activityLogs/fetchUserActivityLogs')());
    }
  }

  transactionClicked = (id) => {
    if (NO_TRANSACTION_HISTORY) {
      return;
    }
    if (!id) {
      return;
    }
    if (!this.isMobile) {
      this.setState({
        showModal: true,
        transactionID: id,
      });
    } else {
      this.props.history.push(`/transaction_history_detail/${id}`);
    }
  };

  reachLimitInfoDidClicked = (id) => {
    if (!id) {
      return;
    }
    if (!this.isMobile) {
      this.setState({
        reachLimitActivityID: id,
      });
    } else {
      this.props.history.push(`/activity_log/${id}/reach_limit`);
    }
  };

  loadMore = () => {
    if (this.props.activityLogPageLink) {
      this.props.dispatch(
        createAction('pullrefreshandloadmore/updateState')({
          ActivityLogLoadingMore: true,
        }),
      );
      this.props.dispatch(
        createAction('activityLogs/uerActivityLogsLoadMore')(),
      );
    }
  };

  parseActivityLog = () => {
    let parsedActivityLogList = [];
    if (
      this.props.activityLogOriginList &&
      this.props.activityLogOriginList.length > 0
    ) {
      parsedActivityLogList = this.props.activityLogOriginList.map((item) => {
        let content = [];
        if (item?.points != null) {
          content.push(
            getLogRewardItem(item?.points, "pts")
          );
        }
        // if (item?.tpe != null) {
        //   content.push(
        //     getLogRewardItem(item?.tpe, "pp")
        //   );
        // }
        if (item?.coupon != null) {
          content.push(
            getLogRewardItem(item?.coupon, i18n.t('home_coupons'))
          );
        }
        if (item?.ticket != null) {
          content.push(
            getLogRewardItem(item?.ticket, i18n.t('home_tickets'))
          );
        }
        if (item?.stamps != null) {
          content.push(
            getLogRewardItem(item?.stamps, "stamps")
          );
        }
        if (item?.level) {
          content.push(item?.level);
        }
        return {
          id: item.activityId,
          name: i18n.t(item.title),
          date: item.activityTime,
          content: content,
          icon: item.icon,
          srcSet: item?.srcSet,
          subTitle: item.subTitle,
          reachLimit: item.reachLimit,
          transactionInfo: item?.transactionInfo,
        };
      });
    }
    return parsedActivityLogList;
  };

  renderTableData = ({
    title,
    dataList,
    isLoading = false,
    isLoadingMore = false,
  }) => {
    if (isLoading) {
      return (
        <tbody>
          <tr>
            <td>
              <LoadMoreSpinner />
            </td>
          </tr>
        </tbody>
      );
    }
    if (dataList && dataList.length > 0) {
      return (
        <tbody>
          {dataList.map((item, index) => {
            return (
              <>
                <tr key={item.id}>
                  <th className="item_name">
                    <div className="type-icon">
                      {item?.icon ? (
                        <img
                          alt="type-icon"
                          src={item?.icon}
                          srcSet={item?.srcSet}
                        />
                      ) : null}
                    </div>
                    <div>
                      <div className="body-3">{item.name}</div>
                      {item?.subTitle && (
                        <div
                          className={`item-sub-title ${
                            this.isMobile ? 'tag-menu-1' : 'body-2'
                          }`}
                        >
                          {item?.subTitle}
                        </div>
                      )}
                      {this.isMobile && (
                        <div className="item-sub-title tag-menu-1">
                          {item?.date}
                        </div>
                      )}
                    </div>
                  </th>
                  {!this.isMobile && (
                    <th className="item_date body-1">{item.date}</th>
                  )}
                  <th
                    className="item-info-content field-text"
                    onClick={() => {
                      if (item?.reachLimit) {
                        this.reachLimitInfoDidClicked(item.id);
                      }
                    }}
                  >
                    {item?.reachLimit ? (
                      <img
                        className="reach-limit-info g3_color_image"
                        src="/action/info.svg"
                      />
                    ) : null}
                    <div className="item-content">
                      {item.content?.map((contentItem, index) => (
                        <div key={index}>{contentItem}</div>
                      ))}
                    </div>
                  </th>
                </tr>
                {/* {item?.transactionInfo?.id ? (
                  <tr className="activity-log-transaction">
                    <th
                      colspan={this.isMobile ? '2' : '3'}
                      onClick={() => {
                        this.transactionClicked(item.transactionInfo.id);
                      }}
                    >
                      <ActivityLogTransactionCard
                        transactionInfo={item?.transactionInfo}
                      />
                    </th>
                  </tr>
                ) : null} */}
              </>
            );
          })}
          {isLoadingMore && (
            <tr>
              <td>
                <LoadMoreSpinner />
              </td>
            </tr>
          )}
        </tbody>
      );
    }
    return (
      <tbody>
        <tr className="no-record-tr">
          <td>
            <p className="no_record_message subheading">
              {i18n.t('no_record_click')}{' '}
              <Link to="/offer/LATEST">{i18n.t('here')}</Link>{' '}
              {i18n.t('to_earn_points')}
            </p>
          </td>
        </tr>
      </tbody>
    );
  };

  tableView = ({
    title,
    itemList,
    isSimple = false,
    isLoading = false,
    isLoadingMore = false,
  }) => {
    const displayItemList =
      isSimple && itemList?.length > 5 ? itemList.slice(0, 5) : itemList;
    return (
      <div className="reward_status_table_view activity-log-table-view">
        <div className="reward_status_table_head">
          <div className="reward_status_table_head_item subheading">
            {title}
          </div>
          {!this.isMobile && (
            <div className="reward_status_table_head_item subheading">
              {i18n.t('ticket_date')}
            </div>
          )}
          <div className="reward_status_table_head_item subheading">
            {i18n.t('earn_burn')}
          </div>
        </div>
        <div
          className={`reward-status-table-body activity-log-table-content ${
            isSimple ? '' : 'scroll-table'
          }`}
          onScroll={(event) => {
            if (
              event.nativeEvent.target.scrollTop +
                event.nativeEvent.target.clientHeight >
                event.nativeEvent.target.scrollHeight * 0.9 &&
              !isLoadingMore
            ) {
              this.loadMore();
            }
          }}
        >
          <Table className="reward-status-table activity-log-table" borderless>
            {this.renderTableData({
              title,
              dataList: displayItemList,
              isLoading,
              isLoadingMore,
            })}
          </Table>
        </div>
      </div>
    );
  };

  handleClick = () => {
    if (this.isMobile) {
      this.props.history.push('/activity_log');
    } else {
      this.setState({
        showModal: true,
        transactionID: null,
      });
    }
  };

  render() {
    const tabs = [
      {
        name: '',
        content: (
          <Row>
            <Col>
              {this.tableView({
                title: i18n.t('activity'),
                itemList: this.parseActivityLog(),
                isLoading: this.props.isLoadingLogs,
                isLoadingMore: this.props.ActivityLogLoadingMore,
              })}
            </Col>
          </Row>
        ),
      },
    ];

    const detailTabs = [
      {
        name: '',
        content: (
          <Row>
            <Col className={'transaction_detail_scroll_view'}>
              {!!this.state.transactionID && (
                <TransactionDetailContent
                  transactionID={this.state.transactionID}
                />
              )}
            </Col>
          </Row>
        ),
      },
    ];
    const detailTitle = (
      <div
        className={'transaction_detail_title'}
        onClick={() => {
          this.setState({
            transactionID: null,
          });
        }}
      >
        <div className="title_back_icon">
          <Image src={LeftArrow} />
        </div>
        <div className={'title title-medium-1'}>
          {i18n.t('records:transaction_detail_title')}
        </div>
      </div>
    );

    const showDetail = !!this.state.transactionID;

    return (
      <Container
        className={`reward-status-section ${
          this.isMobile ? 'mobile-view' : ''
        }`}
      >
        <div className="section-header headline">
          <div className="activity-log-top-bar">
            {i18n.t('profile_activity_log')}
            <ActivityLogFilterDropdown
              onClick={() => {
                this.props.dispatch(
                  createAction('activityLogs/fetchUserActivityLogs')({
                    showNonReward: !this.props.showNonReward,
                  }),
                );
              }}
              isChecked={!!this.props.showNonReward}
            />
          </div>
          <div className="view-all button-small" onClick={this.handleClick}>
            {i18n.t('viewAll')}
          </div>
        </div>
        <Row>
          <Col>
            {this.tableView({
              title: i18n.t('activity'),
              itemList: this.parseActivityLog(),
              isSimple: true,
              isLoading: this.props.isLoadingLogs,
            })}
          </Col>
        </Row>
        {!this.isMobile && (
          <CustomModal
            extendStyle={`${
                showDetail ? 'transaction_detail_popup' : ''
              } ${
                !!this.state.reachLimitActivityID ? 'activity-log-section-modal-none' : ''
            }`}
            title={
              showDetail ? (
                detailTitle
              ) : (
                <div className="activity-log-top-bar">
                  {i18n.t('profile_activity_log')}
                  <ActivityLogFilterDropdown
                    onClick={() => {
                      this.props.dispatch(
                        createAction('activityLogs/fetchUserActivityLogs')({
                          showNonReward: !this.props.showNonReward,
                        }),
                      );
                    }}
                    isChecked={!!this.props.showNonReward}
                  />
                </div>
              )
            }
            tabs={showDetail ? detailTabs : tabs}
            show={this.state.showModal}
            onClose={() => this.setState({ showModal: false, transactionID: null, })}
            hideTab={true}
          />
        )}
        {!this.isMobile && (
          <CustomModal
            title={i18n.t('records:reward_limit_reached')}
            tabs={[
              {
                name: '',
                content: (
                  <>
                    <Row>
                      <Col className={'transaction_detail_scroll_view'}>
                        <ActivityLoginReachLimitContent
                          activityLogId={this.state.reachLimitActivityID}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className={
                          'transaction_detail_scroll_view confirm-button'
                        }
                      >
                        <CustomButton
                          text={i18n.t('ok')}
                          btnClicked={() => {
                            this.setState({ reachLimitActivityID: null });
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                ),
              },
            ]}
            show={!!this.state.reachLimitActivityID}
            hideTab={true}
          />
        )}
      </Container>
    );
  }
}

export default withRouter(ActivityLogSection);
